var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFsn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.934 31c-.056-2.453.234-8.429 1.84-12.71 1.605-4.282 2.564-6.467 2.842-7.024-1.003.055-3.344.3-4.682.836C5.596 12.637 3.087 13.83 2 14.36c.836-1.2 3.094-3.797 5.435-4.6 2.342-.802 5.213-1.393 6.355-1.588.892-1.366 3.211-4.466 5.352-5.937 2.676-1.84 5.435-1.171 6.188-.837.602.268 1.645 1.171 2.09 1.59-1.142-.029-3.863.166-5.602 1.17-1.74 1.003-3.01 2.536-3.428 3.177 1.7.028 5.552.385 7.358 1.59 1.806 1.203 4.21 3.79 5.185 4.933-1.45-.558-5.168-1.856-8.446-2.592-3.278-.736-6.104-.307-7.108 0-1.31 2.34-4.198 7.793-5.269 10.87A666.077 666.077 0 0 1 6.935 31zm14.299-4.097a3.763 3.763 0 1 0 0-7.526 3.763 3.763 0 0 0 0 7.526z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsn);
export default __webpack_public_path__ + "static/media/FSN.4aded7d4467b0869ec939473ead073b6.svg";
export { ForwardRef as ReactComponent };